import { menuItems } from "../../data/footerLinks";
import { Link } from "react-router-dom";

export default function CompanyLinks() {
  return (
    <>
      {menuItems.map((elm, i) => (
        <li key={i}>
          <Link
            to={elm.href}
            className="text-[#020102] dark:text-gray-400 hover:text-[#FF6600] dark:hover:text-white"
          >
            {elm.name}
          </Link>
        </li>
      ))}
    </>
  );
}
